import cn from 'classnames/bind'

import IconSender from './icons/sender.svg'
import IconRecepient from './icons/recepient.svg'

import styles from './DropdownPlaceholder.module.scss';


const cx = cn.bind(styles)

type Props = {
  title: string
  direction: 'from' | 'to'
  disabled?: boolean
}

export const DropdownPlaceholder = ({ title, direction, disabled }: Props) => {
  const icon = direction === 'to' ? <IconRecepient /> : <IconSender />

  return (
    <div className={cx(styles.main, { disabled })}>
      <div className={styles.ava}>
        {icon}
      </div>
      <div className={styles.name}>
        {title}
      </div>
    </div>
  )
}
